import AutomationCommon from "../common";
import AutomationBlockTypes from "../../AutomationBlockTypes";
const vt = AutomationCommon.vt;
const contexts = AutomationCommon.contexts;
const ga = AutomationCommon.ga;
import store from "../../../../../store";
class GetSupsisRecordByIdAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generateUserAttributes(context, prefix) {
        return [
            ga(context, `${prefix}._id`, "User ID", vt.STRING),
            ga(context, `${prefix}.name`, "Name", vt.STRING),
            ga(context, `${prefix}.email`, "Email", vt.STRING),
            ga(context, `${prefix}.phone`, "Phone", vt.STRING),
        ];
    }

    generateFormSubmissionAttributes(context, prefix, formId) {
        console.log("generateFormSubmissionAttributes", { context, prefix, formId });
        const forms = store.state.forms.forms;
        const form = forms.find((f) => f._id === formId);

        if (!form) return [];
        console.log("generateFormSubmissionAttributes form", form);
        const dynamicFormFieldsAttributes = [];
        form.fields.forEach((field) => {
            const fieldPath = `${prefix}.formFields.${field._id}`;
            let fieldLabel = _.get(field, `${field.type}.fieldLabel`);
            let altLabel = _.get(field, `${field.type}.altLabel`) || "";
            let fieldPhone = _.get(field, `${field.type}.fieldPhone`) || "";
            fieldLabel = fieldLabel ? "/" + fieldLabel : "";
            altLabel = altLabel ? "/" + altLabel : "";
            fieldPhone = fieldPhone ? "/" + fieldPhone : "";
            const labelForThisField = `${field.label}${fieldLabel}${altLabel}${fieldPhone}`;

            dynamicFormFieldsAttributes.push(
                ga(context, fieldPath, labelForThisField, vt.OBJECT, undefined, [
                    ga(context, `${fieldPath}._id`, "Field ID", vt.STRING),
                    ga(context, `${fieldPath}.type`, "Field Tipi", vt.STRING),
                    ga(context, `${fieldPath}.label`, "Field Etiketi", vt.STRING),
                    ga(context, `${fieldPath}.required`, "Gerekli mi?", vt.BOOLEAN),
                    ga(context, `${fieldPath}.order`, "Sıra Numarası", vt.NUMBER),
                    ga(context, `${fieldPath}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
                    ga(context, `${fieldPath}.updatedAt`, "Güncelleme Tarihi", vt.DATETIME),
                ])
            );
        });

        const dynamicAnswerAttributes = [];
        form.fields.forEach((field) => {
            const fieldPath = `${prefix}.submission.answers.${field._id}`;
            let fieldLabel = _.get(field, `${field.type}.fieldLabel`);
            let altLabel = _.get(field, `${field.type}.altLabel`) || "";
            let fieldPhone = _.get(field, `${field.type}.fieldPhone`) || "";
            fieldLabel = fieldLabel ? "/" + fieldLabel : "";
            altLabel = altLabel ? "/" + altLabel : "";
            fieldPhone = fieldPhone ? "/" + fieldPhone : "";
            const labelForThisField = `${field.label}${fieldLabel}${altLabel}${fieldPhone}`;

            dynamicAnswerAttributes.push(
                ga(context, fieldPath, labelForThisField, vt.OBJECT, undefined, [
                    ga(context, `${fieldPath}.fieldInfo`, "Alan Bilgisi", vt.OBJECT, undefined, [
                        ga(context, `${fieldPath}.fieldInfo._id`, "Field ID", vt.STRING),
                        ga(context, `${fieldPath}.fieldInfo.type`, "Field Tipi", vt.STRING),
                        ga(context, `${fieldPath}.fieldInfo.label`, "Field Etiketi", vt.STRING),
                        ga(context, `${fieldPath}.fieldInfo.required`, "Gerekli mi?", vt.BOOLEAN),
                        ga(context, `${fieldPath}.fieldInfo.order`, "Sıra Numarası", vt.NUMBER),
                        ga(context, `${fieldPath}.fieldInfo.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
                        ga(context, `${fieldPath}.fieldInfo.updatedAt`, "Güncelleme Tarihi", vt.DATETIME),
                    ]),
                    ga(context, `${fieldPath}.value`, "Cevap Değeri", vt.ANY),
                ])
            );
        });

        return [
            ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
            ga(context, `${prefix}.form`, "Form Bilgisi", vt.OBJECT, undefined, [
                ga(context, `${prefix}.form._id`, "Form ID", vt.STRING),
                ga(context, `${prefix}.form.form_slug`, "Form Slug", vt.STRING),
                ga(context, `${prefix}.form.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.form.title`, "Form Başlığı", vt.STRING),
                ga(context, `${prefix}.form.logo`, "Form Logo", vt.ARRAY_OBJECT, undefined, [
                    ga(context, `${prefix}.form.logo.$..*`, "*", vt.OBJECT),
                    ga(context, `${prefix}.form.logo.$.id`, "Logo Asset ID", vt.STRING),
                    ga(context, `${prefix}.form.logo.$.height`, "Logo Yüksekliği", vt.STRING),
                    ga(context, `${prefix}.form.logo.$.width`, "Logo Genişliği", vt.STRING),
                    ga(context, `${prefix}.form.logo.$.data`, "Logo Asset Verisi", vt.OBJECT),
                ]),
                ga(context, `${prefix}.form.versionNumber`, "Sürüm Numarası", vt.NUMBER),
                ga(context, `${prefix}.form.type`, "Form Tipi", vt.STRING),
                ga(context, `${prefix}.form.visibility`, "Form Görünürlüğü", vt.STRING),
                ga(context, `${prefix}.form.ticketMode`, "Ticket Modu", vt.BOOLEAN),
                ga(context, `${prefix}.form.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
                ga(context, `${prefix}.form.updatedAt`, "Güncelleme Tarihi", vt.DATETIME),
                ga(context, `${prefix}.form.__v`, "Form Versiyon", vt.NUMBER),
                ga(context, `${prefix}.form.settings`, "Form Ayarları", vt.OBJECT),
            ]),
            ga(
                context,
                `${prefix}.formFields`,
                "Form Alanları",
                vt.ARRAY_OBJECT,
                undefined,
                dynamicFormFieldsAttributes
            ),
            ga(context, `${prefix}.submission`, "Submission Bilgisi", vt.OBJECT, undefined, [
                ga(context, `${prefix}.submission._id`, "Submission ID", vt.STRING),
                ga(context, `${prefix}.submission.submittedAt`, "Gönderim Tarihi", vt.DATETIME),
                ga(context, `${prefix}.submission.status`, "Submission Durumu", vt.STRING),
                ga(context, `${prefix}.submission.submission_no`, "Submission No", vt.NUMBER),
                ga(context, `${prefix}.submission.answers`, "Cevaplar", vt.OBJECT, undefined, dynamicAnswerAttributes),
            ]),
        ];
    }

    generateCalendarEventAttributes(context, prefix) {
        /**
         * Reservation Object Structure
         * {"reservation":{"reminderOptions":{"duration":10,"unit":"minute"},"_id":"675af5fdfbfe80c69a726122","isAllDay":false,"repeat":"not_repeat","assets":[],"visibility":"","description":"","color":"","type":"reservation","isCompleted":false,"refUsers":[],"formValues":[{"type":"custom","label":"name","required":true,"isDefault":true,"_id":"66ea9467890fbac5ceb10ecf","value":"mesut"},{"type":"custom","label":"surname","required":true,"isDefault":true,"_id":"66ea9467890fbac5ceb10ed0","value":"yigit"},{"type":"email","label":"email","required":true,"isDefault":true,"_id":"66ea9467890fbac5ceb10ed1","value":"test@test.com"}],"siteId":"5d14ee322d95ad001ebdf213","summary":"Online Görüşme","timezone":"Europe/Istanbul","groupId":"aadab1bc-05c6-4c2b-82c4-616cdf02f769","start":"2024-12-16T08:20:00.000Z","end":"2024-12-16T09:20:00.000Z","createdAt":"2024-12-12T14:41:01.495Z","updatedAt":"2024-12-12T14:41:01.551Z","__v":0,"calendar":{"_id":"662127df06ef2ae98f392b69","userId":"5d14ee322d95ad001ebdf214","summary":"demo@gmail.com","description":"Supsis takvim","type":"supsis"},"user":{"phone":null,"_id":"5d14ee322d95ad001ebdf214","email":"demo@gmail.com","name":"Mesut Temsilci","id":"5d14ee322d95ad001ebdf214"},"reservationPlan":{"availability":{"timezone":"Europe/Istanbul","rules":[{"days":[1],"from":"09:00","to":"18:00","_id":"66ea9467890fbac5ceb10eca"},{"days":[2],"from":"09:00","to":"18:00","_id":"66ea9467890fbac5ceb10ecb"},{"days":[3],"from":"09:00","to":"18:00","_id":"66ea9467890fbac5ceb10ecc"},{"days":[4],"from":"09:00","to":"18:00","_id":"66ea9467890fbac5ceb10ecd"},{"days":[5],"from":"09:00","to":"18:00","_id":"66ea9467890fbac5ceb10ece"}]},"customProgramDates":{"startDate":"2024-09-18T00:00:00.000Z","endDate":"2034-09-18T00:00:00.000Z"},"booking":{"isMaxBookingDay":false,"maxBookingDay":30,"isMinBookingHour":false,"minBookingHour":1},"setting":{"isBufferTimeMinute":false,"bufferTimeMinute":10,"isMaxBookingCountPerDay":false,"maxBookingCountPerDay":5},"_id":"66ea9467890fbac5ceb10ec9","isAvailableNow":true,"availabilityCalendarIds":[],"formInputs":[{"type":"custom","label":"name","required":true,"isDefault":true,"_id":"66ea9467890fbac5ceb10ecf"},{"type":"custom","label":"surname","required":true,"isDefault":true,"_id":"66ea9467890fbac5ceb10ed0"},{"type":"email","label":"email","required":true,"isDefault":true,"_id":"66ea9467890fbac5ceb10ed1"}],"siteId":"5d14ee322d95ad001ebdf213","userId":"5d14ee322d95ad001ebdf214","title":"Online Görüşme","duration":60,"calendarId":"662127df06ef2ae98f392b69","description":"","createdAt":"2024-09-18T08:50:47.798Z","updatedAt":"2024-09-18T08:50:47.798Z","__v":0},"contact":{"_id":"675af5fdfbfe80c69a726124","whatsappInfo":{"isBusiness":false,"isEnterprise":"false","isMe":false,"isMyContact":false,"isPSA":false,"isUser":false,"isWAContact":false},"language":{"modifiedBy":"visitor","approvedByAI":false},"metaLeadInfo":{"status":"new_lead","archived":false},"automationInfo":{"isListenEvent":false},"platform":"calendar","isDeleted":false,"phoneVerified":false,"emailVerified":false,"whatsappNumber":null,"instagramUserId":null,"telegramUserId":null,"telegramInfo":null,"preferredLang":"tr","preferredLangApproved":false,"tags":[],"preferredAgents":[],"relatedDepartments":[],"channel":null,"channelRefId":null,"contacted":false,"otherProfiles":[],"googleInfo":null,"teamGramContactId":null,"flowluAccountId":null,"bitrixContactId":null,"metaLeadId":null,"isLastUpdateByAutomation":false,"vipCustomer":false,"connectionTime":"2024-12-12T14:41:01.505Z","metaReferrals":[],"lastActionTime":"2024-12-12T14:41:01.505Z","siteId":"5d14ee322d95ad001ebdf213","fullname":"mesut yigit","email":"test@test.com","phone":null,"createdAt":"2024-12-12T14:41:01.507Z","updatedAt":"2024-12-12T14:41:01.507Z","__v":0,"conversationCount":0,"contactProperties":{}}}}
         */
        return [
            ga(context, `${prefix}._id`, "Event/Reservation ID", vt.STRING),
            ga(context, `${prefix}.summary`, "Summary", vt.STRING),
            ga(context, `${prefix}.start`, "Start", vt.DATETIME),
            ga(context, `${prefix}.end`, "End", vt.DATETIME),
            ga(context, `${prefix}.isAllDay`, "Is All Day", vt.BOOLEAN),
            ga(context, `${prefix}.isCompleted`, "Is Completed", vt.BOOLEAN),
            ga(context, `${prefix}.color`, "Color", vt.STRING),
            ga(context, `${prefix}.type`, "Type", vt.STRING),
            ga(context, `${prefix}.user`, "User", vt.OBJECT, undefined, [
                ...this.generateUserAttributes(context, `${prefix}.user`),
            ]),
            ga(context, `${prefix}.calendar`, "Calendar", vt.OBJECT, undefined, [
                ga(context, `${prefix}.calendar.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.calendar._id`, "Calendar ID", vt.STRING),
                ga(context, `${prefix}.calendar.summary`, "Summary", vt.STRING),
                ga(context, `${prefix}.calendar.description`, "Description", vt.STRING),
                ga(context, `${prefix}.calendar.type`, "Type", vt.STRING),
                ga(context, `${prefix}.calendar.userId`, "User ID", vt.STRING),
            ]),
            ga(context, `${prefix}.assets`, "Assets", vt.ARRAY_OBJECT, undefined, [
                ga(context, `${prefix}.assets.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.assets._id`, "Asset ID", vt.STRING),
                ga(context, `${prefix}.assets.name`, "Name", vt.STRING),
                ga(context, `${prefix}.assets.path`, "Path", vt.STRING),
                ga(context, `${prefix}.assets.ext`, "Extension", vt.STRING),
                ga(context, `${prefix}.assets.size`, "Size", vt.NUMBER),
                ga(context, `${prefix}.assets.cdnUrl`, "CDN URL", vt.STRING),
            ]),
            ga(context, `${prefix}.refUsers`, "Ref Users", vt.ARRAY_OBJECT, undefined, [
                ga(context, `${prefix}.refUsers.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.refUsers._id`, "User ID", vt.STRING),
                ga(context, `${prefix}.refUsers.name`, "Name", vt.STRING),
                ga(context, `${prefix}.refUsers.email`, "Email", vt.STRING),
                ga(context, `${prefix}.refUsers.phone`, "Phone", vt.STRING),
            ]),
            ga(context, `${prefix}.reservationPlan`, "Reservation Plan", vt.OBJECT, undefined, [
                ga(context, `${prefix}.reservationPlan.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.reservationPlan._id`, "Reservation Plan ID", vt.STRING),
                ga(context, `${prefix}.reservationPlan.title`, "Title", vt.STRING),
                ga(context, `${prefix}.reservationPlan.description`, "Description", vt.STRING),
                ga(context, `${prefix}.reservationPlan.duration`, "Duration", vt.NUMBER),
                ga(context, `${prefix}.reservationPlan.availability`, "Availability", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.reservationPlan.availability.timezone`, "Timezone", vt.STRING),
                    ga(context, `${prefix}.reservationPlan.availability.rules`, "Rules", vt.ARRAY_OBJECT, undefined, [
                        ga(context, `${prefix}.reservationPlan.availability.rules.days`, "Days", vt.ARRAY_NUMBER),
                        ga(context, `${prefix}.reservationPlan.availability.rules.from`, "From", vt.STRING),
                        ga(context, `${prefix}.reservationPlan.availability.rules.to`, "To", vt.STRING),
                    ]),
                ]),
                ga(context, `${prefix}.reservationPlan.booking`, "Booking", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.reservationPlan.booking.isMaxBookingDay`, "Is Max Booking Day", vt.BOOLEAN),
                    ga(context, `${prefix}.reservationPlan.booking.maxBookingDay`, "Max Booking Day", vt.NUMBER),
                    ga(
                        context,
                        `${prefix}.reservationPlan.booking.isMinBookingHour`,
                        "Is Min Booking Hour",
                        vt.BOOLEAN
                    ),
                    ga(context, `${prefix}.reservationPlan.booking.minBookingHour`, "Min Booking Hour", vt.NUMBER),
                ]),
                ga(context, `${prefix}.reservationPlan.setting`, "Setting", vt.OBJECT, undefined, [
                    ga(
                        context,
                        `${prefix}.reservationPlan.setting.isBufferTimeMinute`,
                        "Is Buffer Time Minute",
                        vt.BOOLEAN
                    ),
                    ga(context, `${prefix}.reservationPlan.setting.bufferTimeMinute`, "Buffer Time Minute", vt.NUMBER),
                    ga(
                        context,
                        `${prefix}.reservationPlan.setting.isMaxBookingCountPerDay`,
                        "Is Max Booking Count Per Day",
                        vt.BOOLEAN
                    ),
                    ga(
                        context,
                        `${prefix}.reservationPlan.setting.maxBookingCountPerDay`,
                        "Max Booking Count Per Day",
                        vt.NUMBER
                    ),
                ]),
                ga(
                    context,
                    `${prefix}.reservationPlan.availabilityCalendarIds`,
                    "Availability Calendar IDs",
                    vt.ARRAY_STRING
                ),
                ga(context, `${prefix}.reservationPlan.calendarId`, "Calendar ID", vt.STRING),
                ga(context, `${prefix}.reservationPlan.formInputs`, "Form Inputs", vt.ARRAY_OBJECT, undefined, [
                    ga(context, `${prefix}.reservationPlan.formInputs.type`, "Type", vt.STRING),
                    ga(context, `${prefix}.reservationPlan.formInputs.label`, "Label", vt.STRING),
                    ga(context, `${prefix}.reservationPlan.formInputs.required`, "Required", vt.BOOLEAN),
                    ga(context, `${prefix}.reservationPlan.formInputs.isDefault`, "Is Default", vt.BOOLEAN),
                ]),
                ga(context, `${prefix}.reservationPlan.createdAt`, "Created At", vt.DATETIME),
                ga(context, `${prefix}.reservationPlan.updatedAt`, "Updated At", vt.DATETIME),
            ]),
            ga(context, `${prefix}.contact`, "Contact", vt.OBJECT, undefined, [
                ...this.parent.generateContactAttributes(`${prefix}.contact`),
            ]),
            //formValues
            ga(context, `${prefix}.formValues`, "Form Values", vt.ARRAY_OBJECT, undefined, [
                ga(context, `${prefix}.formValues.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.formValues.$.type`, "Type", vt.STRING),
                ga(context, `${prefix}.formValues.$.label`, "Label", vt.STRING),
                ga(context, `${prefix}.formValues.$.value`, "Value", vt.STRING),
            ]),
            //formData
            ga(context, `${prefix}.formData`, "Form Data", vt.OBJECT, undefined, [
                ga(context, `${prefix}.formData.$..*`, "*", vt.STRING),
                ga(context, `${prefix}.formData.$.name`, "Name (Standart)", vt.STRING),
                ga(context, `${prefix}.formData.$.surname`, "Surname (Standart)", vt.STRING),
                ga(context, `${prefix}.formData.$.email`, "Email (Standart)", vt.STRING),
                ga(context, `${prefix}.formData.$.phone`, "Phone (Standart)", vt.STRING),
            ]),
        ];
    }
    generate(prefix, block) {
        if (block.type !== AutomationBlockTypes.GET_SUPSIS_RECORD_BY_ID) {
            console.warn(`GetSupsisRecordByIdAttributeFactory not supported for ${block.type}`);
            return [];
        }
        const context = contexts.BLOCK;
        const module = block.payload?.module;

        if (!module) {
            console.warn(`GetSupsisRecordByIdAttributeFactory called  without module`);
            return [];
        }
        let attributes = [];

        if (module === "ticket") {
            attributes = [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}._id`, "Ticket ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.subject`, "Subject", vt.STRING),
                ga(context, `${prefix}.status`, "Status", vt.STRING),
                ga(context, `${prefix}.tag`, "Tag", vt.STRING),
                ga(context, `${prefix}.type`, "Type", vt.STRING),
                ga(context, `${prefix}.visitorEmailAddress`, "Visitor Email Address", vt.STRING),
                ga(context, `${prefix}.visitorPhoneNumber`, "Visitor Phone Number", vt.STRING),
                ga(context, `${prefix}.resolved`, "Is Resolved", vt.BOOLEAN),
                ga(context, `${prefix}.resolvedDate`, "Resolved Date", vt.DATETIME),
                ga(context, `${prefix}.assignedUser`, "Assigned User", vt.OBJECT, undefined, [
                    ...this.generateUserAttributes(context, `${prefix}.assignedUser`),
                ]),
                ga(context, `${prefix}.rate`, "Rate", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Created At", vt.DATETIME),
                ga(context, `${prefix}.updatedAt`, "Updated At", vt.DATETIME),
                ga(context, `${prefix}.contact`, "Contact", vt.OBJECT, undefined, [
                    ...this.parent.generateContactAttributes(`${prefix}.contact`),
                ]),
                //response
                ga(context, `${prefix}.response`, "Response", vt.STRING),
                ga(context, `${prefix}.osrPayload`, "OSR Payload", vt.OBJECT),
                //returnType
                ga(context, `${prefix}.returnType`, "Return Type", vt.STRING),
                //ticketMessage
                ga(context, `${prefix}.ticketMessage`, "Ticket Message", vt.STRING),
                //createdByChatbot
                ga(context, `${prefix}.createdByChatbot`, "Created By Chatbot", vt.BOOLEAN),
                //chat
                ga(context, `${prefix}.chat`, "Chat", vt.OBJECT, undefined, [
                    ...this.parent.generateConversationAttributes(`${prefix}.chat`),
                ]),
            ];
        } else if (module === "task") {
            attributes = [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}._id`, "Task ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.title`, "Title", vt.STRING),
                ga(context, `${prefix}.description`, "Description", vt.STRING),
                ga(context, `${prefix}.priority`, "Priority", vt.STRING),
                ga(context, `${prefix}.pipelineStage`, "Stage", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.pipelineStage._id`, "Stage Id", vt.STRING),
                    ga(context, `${prefix}.pipelineStage.name`, "Stage Name", vt.STRING),
                ]),
                ga(context, `${prefix}.assignees`, "Assignees", vt.ARRAY_OBJECT, undefined, [
                    ga(context, `${prefix}.assignees.$.._id`, "User Id", vt.STRING),
                    ...this.generateUserAttributes(context, `${prefix}.assignees.$.`),
                ]),
                //collaborators
                ga(context, `${prefix}.collaborators`, "Collaborators", vt.ARRAY_OBJECT, undefined, [
                    ...this.generateUserAttributes(context, `${prefix}.collaborators.$.`),
                ]),
                //followers
                ga(context, `${prefix}.followers`, "Followers", vt.ARRAY_OBJECT, undefined, [
                    ...this.generateUserAttributes(context, `${prefix}.followers.$.`),
                ]),
                ga(context, `${prefix}.owner`, "Owner", vt.OBJECT, undefined, [
                    ...this.generateUserAttributes(context, `${prefix}.owner`),
                ]),
                ga(context, `${prefix}.endDate`, "Due Date", vt.DATETIME),
                ga(context, `${prefix}.completed`, "Is Completed", vt.BOOLEAN),
                ga(context, `${prefix}.archived`, "Is Archived", vt.BOOLEAN),
                ga(context, `${prefix}.tags`, "Tags", vt.ARRAY_OBJECT, undefined, [
                    ga(context, `${prefix}.tags.$.._id`, "Tag Id", vt.STRING),
                    ga(context, `${prefix}.tags.$..name`, "Name", vt.STRING),
                ]),
                ga(context, `${prefix}.createdAt`, "Created At", vt.DATETIME),
                ga(context, `${prefix}.updatedAt`, "Updated At", vt.DATETIME),
                //checklist
                ga(context, `${prefix}.checklist`, "Checklist", vt.ARRAY_OBJECT, undefined, [
                    ga(context, `${prefix}.checklist.$..*`, "*", vt.OBJECT),
                    ga(context, `${prefix}.checklist.$.title`, "Title", vt.STRING),
                    ga(context, `${prefix}.checklist.$.isCompleted`, "Is Completed", vt.BOOLEAN),
                ]),
                ga(context, `${prefix}.relations`, "Relations", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.relations.$..*`, "*", vt.OBJECT),
                    ga(context, `${prefix}.relations.type`, "Type", vt.STRING),
                    ga(context, `${prefix}.relations.visitor`, "Contact ID", vt.STRING),
                    ga(context, `${prefix}.relations.conversation`, "Chat ID", vt.STRING),
                    ga(context, `${prefix}.relations.mail`, "Mail ID", vt.STRING),
                    ga(context, `${prefix}.relations.message`, "Message ID", vt.STRING),
                ]),
                ga(context, `${prefix}.contact`, "Contact", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.contact.$..*`, "*", vt.OBJECT),
                    ...this.parent.generateContactAttributes(`${prefix}.contact`),
                ]),
                ga(context, `${prefix}.chat`, "Chat", vt.OBJECT, undefined, [
                    ...this.parent.generateConversationAttributes(`${prefix}.chat`),
                ]),
                ga(context, `${prefix}.message`, "Message", vt.OBJECT, undefined, [
                    ...this.parent.generateMessageAttributes(`${prefix}.message`),
                ]),
                //dates
                ga(context, `${prefix}.dates`, "Dates", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.dates.updateDate`, "Updated At", vt.DATETIME),
                    ga(context, `${prefix}.dates.doneDate`, "Done Date", vt.DATETIME),
                    ga(context, `${prefix}.dates.archivedDate`, "Archived Date", vt.DATETIME),
                ]),
                //createdBy
                ga(context, `${prefix}.createdBy`, "Created By", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.createdBy.$..*`, "*", vt.OBJECT),
                    ga(context, `${prefix}.createdBy.type`, "Who", vt.STRING),
                    ga(context, `${prefix}.createdBy.user`, "User", vt.OBJECT, undefined, [
                        ...this.generateUserAttributes(context, `${prefix}.createdBy.user`),
                    ]),
                ]),
                /**   "estimatedTime": {"hour": 0,"minute": 0,"totalMinute": 0}, */
                ga(context, `${prefix}.estimatedTime`, "Estimated Time", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.estimatedTime.hour`, "Hour", vt.NUMBER),
                    ga(context, `${prefix}.estimatedTime.minute`, "Minute", vt.NUMBER),
                    ga(context, `${prefix}.estimatedTime.totalMinute`, "Total Minute", vt.NUMBER),
                ]),
                //workflow
                ga(context, `${prefix}.workflow`, "Workflow", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.workflow._id`, "ID", vt.STRING),
                    ga(context, `${prefix}.workflow.title`, "Title", vt.STRING),
                    ga(context, `${prefix}.workflow.description`, "Description", vt.STRING),
                    ga(context, `${prefix}.workflow.default`, "Default", vt.BOOLEAN),
                ]),
            ];
        } else if (module === "email") {
            attributes = [];
        } else if (module === "message") {
            attributes = [];
        } else if (module === "calendar-event") {
            attributes = [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ...this.generateCalendarEventAttributes(context, `${prefix}`),
            ];
        } else if (module === "reservation") {
            attributes = [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ...this.generateCalendarEventAttributes(context, `${prefix}`),
            ];
        } else if (module === "chat") {
            attributes = [...this.parent.generateConversationAttributes(`${prefix}`)];
        } else if (module === "user") {
            attributes = [...this.generateUserAttributes(context, `${prefix}`)];
        } else if (module === "contact") {
            attributes = [...this.parent.generateContactAttributes(`${prefix}`)];
        } else if (module === "formSubmission") {
            const formId = block.payload.formId;
            const formAttrs = this.generateFormSubmissionAttributes(context, prefix, formId);
            attributes = [...formAttrs];
        }
        return attributes;
    }
}

export default GetSupsisRecordByIdAttributeFactory;
